<template>
	<div class="listing-size-detail">
		<div class="page-info">
			<span class="info-tag">尺码绑定</span>
			平台订单系统尺码与拼多多系统尺码绑定，店铺：
			<span class="shop-name">{{ shopName }}</span>
		</div>

		<div class="save-bar">
			<el-button type="primary" @click="onSave">保存</el-button>
		</div>

		<div
			v-for="category in categories"
			:key="category.key"
			class="category-block"
		>
			<div class="category-row">
				<div class="cat-label">{{ category.name }}</div>
				<div class="size-grid">
					<div v-for="(item, idx) in category.sizes" :key="idx" class="size-cell">
						<span class="size-name">{{ item.size }}</span>
						<div class="size-field">
							<span class="field-label">拼多多尺码</span>
							<el-input v-model="item.pddSize" size="mini" />
						</div>
						<div class="size-field">
							<span class="field-label">尺码备注</span>
							<el-input v-model="item.remark" size="mini" placeholder="" />
						</div>
					</div>
				</div>
			</div>

			<div class="upload-section">
				<div class="upload-panel">
					<p class="upload-tip">
						详情图头部，附加图，最多可上传 5 张，尺寸要求宽度处于 480~1200px 之间，高度 0~1500px 之间，大小 1M 以内，在一键上架商品的详情图头部自动加上配置的图片
					</p>
					<el-upload
						class="image-uploader"
						action="#"
						list-type="picture-card"
						:limit="5"
						:auto-upload="false"
						:file-list="category.headerImages"
						:on-change="(file, fileList) => handleHeaderImageChange(category.key, fileList)"
						:on-remove="(file, fileList) => handleHeaderImageChange(category.key, fileList)"
					>
						<div class="upload-trigger">
							<i class="el-icon-picture-outline" />
							<span>上传图片</span>
						</div>
					</el-upload>
				</div>

				<div class="upload-panel">
					<p class="upload-tip">
						详情图尾部，附加图，最多可上传 5 张，尺寸要求宽度处于 480~1200px 之间，高度 0~1500px 之间，大小 1M 以内，在一键上架商品的详情图底部自动加上配置的图片
					</p>
					<el-upload
						class="image-uploader"
						action="#"
						list-type="picture-card"
						:limit="5"
						:auto-upload="false"
						:file-list="category.footerImages"
						:on-change="(file, fileList) => handleFooterImageChange(category.key, fileList)"
						:on-remove="(file, fileList) => handleFooterImageChange(category.key, fileList)"
					>
						<div class="upload-trigger">
							<i class="el-icon-picture-outline" />
							<span>上传图片</span>
						</div>
					</el-upload>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
const letterSizes = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL', '5XL', '6XL', '7XL']
const childClothSizes = [52, 59, 66, 73, 80, 90, 100, 110, 120, 130, 135, 140, 145, 150, 155, 160, 165, 170, 175, 180]
const menShoeSizes = [4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12, 12.5, 13]
const womenShoeSizes = [4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5]
const childShoeSizes = ['5C', '6C', '7C', '8C', '9C', '10C', '11C', '12C', '13C', '1', '1.5', '2', '2.5', '3', '3.5', '4', '4.5', '5', '5.5', '6', '6.5', '7', '7.5', '8', '8.5', '9']
const accessorySizes = ['S', 'M', 'L', 'XL', '0', 'F', 'TG', 'OS']

const menShoePddSizes = ['35.5', '36', '37', '37.5', '38', '39', '39.5', '40', '41', '41.5', '42', '43', '43.5', '44', '45', '45.5', '46', '47', '47.5']
const womenShoePddSizes = ['34', '35', '35.5', '36', '37', '37.5', '38', '39', '39.5', '40', '41']

const accessoryPddMap = {
	S: 'S',
	M: 'M',
	L: 'L',
	XL: 'XL',
	0: '均码-0',
	F: '均码-F',
	TG: '均码-T',
	OS: '均码-O',
}

const createSameSizeBindings = sizes =>
	sizes.map(size => ({
		size: String(size),
		pddSize: String(size),
		remark: '',
	}))

const createPairedBindings = (sizes, pddSizes) =>
	sizes.map((size, index) => ({
		size: String(size),
		pddSize: String(pddSizes[index] != null ? pddSizes[index] : size),
		remark: '',
	}))

const createAccessoryBindings = () =>
	accessorySizes.map(size => ({
		size: String(size),
		pddSize: accessoryPddMap[size] || String(size),
		remark: '',
	}))

const createChildShoeBindings = () =>
	childShoeSizes.map((size, index) => ({
		size: String(size),
		pddSize: String(20 + index),
		remark: '',
	}))

const createCategory = (key, name, sizes) => ({
	key,
	name,
	sizes,
	headerImages: [],
	footerImages: [],
})

const createCategories = () => [
	createCategory('men_cloth', '男服装', createSameSizeBindings(letterSizes)),
	createCategory('women_cloth', '女服装', createSameSizeBindings(letterSizes)),
	createCategory('child_cloth', '童服装', createSameSizeBindings(childClothSizes)),
	createCategory('mid_cloth', '中服装', createSameSizeBindings(letterSizes)),
	createCategory('men_shoe', '男鞋', createPairedBindings(menShoeSizes, menShoePddSizes)),
	createCategory('women_shoe', '女鞋', createPairedBindings(womenShoeSizes, womenShoePddSizes)),
	createCategory('child_shoe', '童鞋', createChildShoeBindings()),
	createCategory('mid_shoe', '中鞋', createPairedBindings(menShoeSizes, menShoePddSizes)),
	createCategory('men_acc', '男配件', createAccessoryBindings()),
	createCategory('women_acc', '女配件', createAccessoryBindings()),
	createCategory('mid_acc', '中配件', createAccessoryBindings()),
]

export default {
	name: 'ListingSizeDetail',
	data() {
		return {
			shopName: '驰方户外运动专营店',
			categories: createCategories(),
		}
	},
	methods: {
		handleHeaderImageChange(categoryKey, fileList) {
			this.onImageChange(categoryKey, 'header', fileList)
		},
		handleFooterImageChange(categoryKey, fileList) {
			this.onImageChange(categoryKey, 'footer', fileList)
		},
		onImageChange(categoryKey, type, fileList) {
			const category = this.categories.find(item => item.key === categoryKey)
			if (!category) return
			if (type === 'header') {
				category.headerImages = fileList
			} else {
				category.footerImages = fileList
			}
		},
		onSave() {
			this.$message.success('保存成功')
		},
	},
}
</script>

<style scoped lang="less">
.listing-size-detail {
	padding: 24px 28px 40px;
	background: #fff;
	min-height: 100%;
	box-sizing: border-box;
	overflow-x: hidden;
}

.page-info {
	margin-bottom: 20px;
	padding: 14px 18px;
	font-size: 14px;
	line-height: 1.6;
	color: #606266;
	background: #fafbfc;
	border-left: 3px solid #67c23a;
	border-radius: 0 6px 6px 0;

	.info-tag {
		display: inline-block;
		margin-right: 8px;
		padding: 2px 10px;
		font-size: 12px;
		color: #409eff;
		background: rgba(64, 158, 255, 0.08);
		border-radius: 3px;
		vertical-align: middle;
	}

	.shop-name {
		color: #ff4714;
		font-weight: 500;
	}
}

.save-bar {
	margin-bottom: 24px;

	.el-button {
		min-width: 96px;
		height: 36px;
	}
}

.category-block {
	margin-bottom: 20px;
	padding: 16px 16px 20px;
	background: #fafbfc;
	border: 1px solid #f0f2f5;
	border-radius: 6px;
}

.category-row {
	display: flex;
	align-items: stretch;
	margin-bottom: 16px;
	border: 1px solid #f0f2f5;
	border-radius: 6px;
	overflow: hidden;
	background: #fafbfc;
}

.cat-label {
	flex-shrink: 0;
	width: 64px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 12px 6px;
	font-size: 13px;
	font-weight: 500;
	color: #606266;
	background: #fafbfc;
	border-right: 1px solid #f0f2f5;
	text-align: center;
	line-height: 1.4;
	word-break: break-all;
}

.size-grid {
	flex: 1;
	min-width: 0;
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(72px, 1fr));
	gap: 8px;
	padding: 10px 8px;
	box-sizing: border-box;
	background: #fafbfc;
}

.size-cell {
	min-width: 0;
	padding: 8px 4px;
	background: #fff;
	border-radius: 4px;
	border: 1px solid #eef0f3;
	box-sizing: border-box;
}

.size-name {
	display: block;
	margin-bottom: 6px;
	font-size: 12px;
	font-weight: 500;
	color: #303133;
	text-align: center;
	line-height: 1.3;
}

.size-field {
	& + .size-field {
		margin-top: 6px;
	}

	.field-label {
		display: block;
		margin-bottom: 4px;
		font-size: 11px;
		color: #909399;
		text-align: center;
		line-height: 1.2;
	}

	/deep/ .el-input__inner {
		height: 28px;
		line-height: 28px;
		padding: 0 6px;
		font-size: 12px;
		text-align: center;
		border-color: #e8eaed;
		border-radius: 4px;
		background: #fafbfc;

		&:hover {
			border-color: #dcdfe6;
			background: #fff;
		}

		&:focus {
			border-color: #ff4714;
			background: #fff;
		}
	}
}

.upload-section {
	display: flex;
	flex-direction: column;
	gap: 16px;
}

.upload-panel {
	padding: 14px 16px;
	background: #fff;
	border: 1px solid #eef0f3;
	border-left: 3px solid #67c23a;
	border-radius: 0 6px 6px 0;
}

.upload-tip {
	margin: 0 0 12px;
	font-size: 12px;
	color: #909399;
	line-height: 1.7;
}

.image-uploader {
	/deep/ .el-upload-list--picture-card .el-upload-list__item {
		width: 88px;
		height: 88px;
		border-radius: 4px;
	}

	/deep/ .el-upload--picture-card {
		width: 88px;
		height: 88px;
		line-height: normal;
		border: 1px dashed #dcdfe6;
		border-radius: 4px;
		background: #fafbfc;

		&:hover {
			border-color: #ff4714;
		}
	}
}

.upload-trigger {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
	color: #909399;

	i {
		font-size: 22px;
		margin-bottom: 4px;
	}

	span {
		font-size: 12px;
		line-height: 1.2;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/StoreConfig/detailed/listingSizeDetail.vue